var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"buy_footer"},[_c('div',{staticClass:"price"},[_vm._v("\n    总价：¥ "),_c('span',[_vm._v(_vm._s(_vm.price))])]),_c('div',{staticClass:"btn",class:{disabled: _vm.disabled},on:{"click":_vm.handleClick}},[_vm._v("确定")])])}
var staticRenderFns = []

export { render, staticRenderFns }